Wee.fn.make('signupForm', {
    init: function() {
        var scope = this,
            results = [],
            rules = [
                [
                    '.js-first-name',
                    'required'
                ],
                [
                    '.js-last-name',
                    'required'
                ],
                [
                    '.js-email',
                    'required|email'
                ],
                [
                    '.js-email-confirm',
                    'required|email|confirm:js-email'
                ]
            ];

        Wee.modal.init();

        $.events.on({
            'ref:csRadio': {
                change: function() {
                    Wee.$prop('ref:csRadio', 'checked', true);
                    $('ref:csFields').show();
                }
            },
            'ref:hsRadio': {
                change: function() {
                    Wee.$prop('ref:hsRadio', 'checked', true);
                    $('ref:csFields').hide();
                }
            },
            'ref:signupModalBtn': {
                click: function() {
                    var $email = $('ref:signupEmail');

                    if ($email.val() === '') {
                        $email.val($('ref:signupInitialEmail').val());
                    }
                }
            },
            'ref:signupModalForm': {
                submit: function(e, el) {
                    var $form = $form;
                    
                    if (Wee.$prop('ref:csRadio', 'checked')) {
                        rules.push([
                            '.js-school-name',
                            'required'
                        ]);
        
                        rules.push([
                            '.js-zipcode',
                            'required|numeric'
                        ]);
                    }

                    results = Wee.validate.run(rules);

                    $('.form-input-error').hide();
                    $('.js-modal-input').removeClass('-has-error');

                    if (! results.length) {
                        scope.submitForm(el);
                    } else {
                        for (var i = 0; i < results.length; i++) {
                            var modifier = '-' + results[i][1] + '-error';

                            $(results[i][0] + modifier).show();
                            $(results[i][0]).addClass('-has-error');
                        }
                    }

                    e.preventDefault();
                }
            },
            'ref:signupModal': {
                keydown: function(e) {
                    if ((e.shiftKey && e.keyCode === 9) || e.keyCode === 9) {
                        scope.trapFocus(e);
                    } else if (e.keyCode === 27) {
                        $('ref:signupModalOverlay').hide();
                        $('ref:signupModalBtn')[0].focus();
                    }
                }
            }
        });
    },

    submitForm: function(el) {
        var scope = this,
            $form = $(el);

        scope.toggleButton();

        $.fetch.request({
            url: $form.attr('action'),
            method: 'post',
            data: $form.serialize(),
            type: 'text',
            success: function(data) {
                scope.showSuccessMessage();

                // Enable button
                scope.toggleButton();
            },
            error: function(data) {
                $('ref:signupFormGlobalError').text('There was a problem submitting your form');

                // Enable button
                scope.toggleButton();
            }
        });

        setTimeout(function() {
            scope.toggleButton();
        }, 5000);
    },

    toggleButton: function() {
        var $button = $('ref:signupSubmit');

        if ($button.prop('disabled')) {
            $button.prop('disabled', false)
                .text('Submit');
        } else {
            $button.prop('disabled', true)
                .text('Submitting...');
        }
    },

    showSuccessMessage: function() {
        Wee.modal.close();

        $('ref:signupFormBlock').html(
            $.view.render('reusable-blocks-success', {
                heading: $.get('thankYouHeading'),
                body: $.get('thankYouBody')
            }
        ));
    },

    trapFocus: function(e) {
        var first = $('ref:signupClose')[0];
        var last = $('ref:signupSubmit')[0];

        if (e.shiftKey) {
            if (document.activeElement === first) {
                last.focus();
                e.preventDefault();
            }
        } else if (document.activeElement === last) {
            first.focus();
            e.preventDefault();
        }
    }
});

Wee.signupForm.init();
